import BranchCard from '@/components/branch-card';
import ImageOptimizer from '@/components/image-optimizer';
import {
  AcademyBreadcrumbItem,
  BranchBreadcrumbItem,
} from '@/data/globals.data';
import { useHotStoreList } from '@/services/query/store.query';
import Image from 'next/image';
import Link from 'next/link';

export default function HotBranchesSection() {
  const { data: branchList } = useHotStoreList();

  return (
    <div className="desktop:web-w desktop:mx-auto desktop:pt-[134px] w-full pt-[60px] text-center">
      <div className="flex flex-col items-center justify-center gap-5">
        <ImageOptimizer
          src="/images/icons/icon_hot.svg"
          alt="Hot"
          width={72}
          height={36}
          className="desktop:hidden"
        />
        {/* 헤더 */}
        <div className="relative inline-block">
          <h2 className="typo-28 text-level-2 desktop:typo-50 desktop:pb-15 pb-6 leading-snug font-black">
            지금, 가장 인기있는
            <br className="desktop:hidden" /> 지점이에요!
          </h2>

          <ImageOptimizer
            src="/images/icons/hot_bubble.svg"
            alt="Hot"
            width={78}
            height={41}
            className="desktop:inline-block absolute -top-8 -right-12 hidden"
          />
        </div>
      </div>

      {/* Flex 레이아웃으로 3개씩 가로 나열 */}
      <div className="desktop:grid-cols-3 grid grid-cols-1 justify-center gap-9">
        {branchList?.data?.map((branch) => (
          <BranchCard {...branch} key={branch.id} />
        ))}
      </div>

      {/* 전체 지점보기 · 운전면허학원 찾기 — 학원 찾기는 홈에서 튀지 않게 지점보기와 같은 글자 링크로 둔다 */}
      <div className="desktop:pt-20 desktop:flex-row desktop:gap-8 flex flex-col items-center justify-center gap-4 pt-10">
        <Link
          href={BranchBreadcrumbItem.href}
          className="inline-flex items-center"
        >
          <span className="typo-18 text-level-2 desktop:typo-24 mr-2 inline-block font-bold">
            전체 지점보기
          </span>
          <Image
            src="/images/icons/icon_arrow_right.svg"
            alt=""
            width={16}
            height={16}
          />
        </Link>
        <span
          aria-hidden
          className="bg-stroke-grayblue desktop:block hidden h-5 w-px"
        />
        <Link
          href={AcademyBreadcrumbItem.href}
          className="inline-flex items-center"
        >
          <span className="typo-18 text-level-6 desktop:typo-24 mr-2 inline-block font-bold">
            운전면허학원 찾기
          </span>
          <Image
            src="/images/icons/icon_arrow_right.svg"
            alt=""
            width={16}
            height={16}
            className="opacity-50"
          />
        </Link>
      </div>
    </div>
  );
}
